var mp = mp || {};


// PopUp - Success
//-----------------------------------------------------------------
mp.popupSuccess = function($content) {
    $.fancybox.close(true);
    $.fancybox.open({
        src  : '#form-response--success',
        type : 'inline',
        modal: true,
    });
}



// PopUp - Error
//-----------------------------------------------------------------
mp.popupError = function($content) {
    $.fancybox.close(true);
    $.fancybox.open({
        src  : '#form-response--error',
        type : 'inline',
        modal: true,
    });
}